<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="disclaimer"><a id="page_13"></a><em>Disclaimer</em></h2>
<p class="noindent"><strong>T</strong>his book is intended to provide accurate and helpful information. However, readers are strongly encouraged to consult with a healthcare professional before using any of the information contained in this book. Neither the author or the publisher is engaged in rendering medical advice or services. Accordingly, the publisher and author disclaim any liability, loss, damage, or injury caused by the use or application of the contents of this work. NO WARRANTY, EXPRESS OR IMPLIED, IS DELIVERED BY THE AUTHOR OR PUBLISHER WITH RESPECT TO THE CONTENTS OF THIS WORK.<a id="page_14"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// disclaimer.vue?645f7eeb